var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content member_grade"},[_c('PageTitle',[_vm._v(_vm._s(_vm.$t('MEMBER_GRADE_TITLE')))]),_c('admin-iframe',{attrs:{"src":_vm.remoteSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }